<app-section-quick-actions section="item" />

<header class="atmos-page__header">
  <h1 class="atmos-page__title">Item inflation</h1>
</header>

<div class="atmos-page__intro">
  <p class="atmos-paragraph">
    This graph displays the cost of items when they were first available for purchase using candles.
    The blue line represents these costs by the date the item was introduced in the game, while the pink line represents the date the item first became available for regular candles.
    If an item was introduced for regular candles, both lines will coincide on the same date.
    When multiple items were introduced in the same month, the graph will display the average cost of that month.
  </p>
  <p class="atmos-paragraph">
    This can help give a general idea of what prices to expect for new items once they return.
  </p>
</div>

<section class="atmos-card">
  <div class="atmos-card__body">
    <h2 class="atmos-section__title">Filters</h2>
    <app-item-type-nav [entries]="typeEntries" [active]="itemType" [wrap]="true" [buttons]="true"
      (typeSelected)="onTypeChanged($event)"/>
    <div class="atmos-item-inflation__toggles">
      <button type="button" class="atmos-btn atmos-btn--sm"
        [class.atmos-btn--active]="includeSeasons" (click)="toggleIncludeSeasons()">
        Show season items
      </button>
      <button type="button" class="atmos-btn atmos-btn--sm"
        [class.atmos-btn--active]="includeEvents" (click)="toggleIncludeEvents()">
        Show event items
      </button>
    </div>
  </div>
</section>

@if (!chartItems?.length) {
  <section class="atmos-card">
    <div class="atmos-card__body">
      <p class="atmos-paragraph">No items found in this category.</p>
    </div>
  </section>
}

<section class="atmos-card" [hidden]="!chartItems?.length">
  <div class="atmos-card__body">
    <div class="atmos-item-inflation__chart-wrap">
      <canvas #chart class="atmos-item-inflation__chart"></canvas>
    </div>
  </div>
</section>
